import styled from "styled-components";

export const CommonButtonWrapper = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "fullWidth",
})<{ fullWidth?: boolean }>`
  width: ${(props) => (props?.fullWidth ? "100%" : "auto")};
  padding: 15px;
  min-width: 295px;
  min-height: 52px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 20px;
  text-transform: capitalize;
  cursor: pointer;
  transition: 0.4s ease-in-out;
  @media (max-width: 1199px) {
    font-size: 16px;
    min-width: 200px;
    padding: 10px;
  }
  @media (max-width: 899px) {
    border-radius: 12px;
  }
  .cmn_icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &.end_icon {
      margin-left: 14px;
    }
    &.start_icon {
      margin-right: 14px;
    }
  }

  &.contained {
    &.primary {
      background: rgb(255, 24, 24);
      color: rgb(255, 235, 235);
      &:hover {
        color: rgb(0, 0, 0);
        background: rgb(255, 235, 235);
      }
    }
    &.secondary {
      background: rgb(255, 235, 235);
      color: rgb(0, 0, 0);
      &:hover {
        color: rgb(255, 235, 235);
        background: rgb(255, 24, 24);
      }
    }
  }
`;
